<template>
  <svg
    width="260"
    height="374"
    viewBox="0 0 260 374"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="30.5" y="21.5" width="199.6" height="405.2" rx="18.6" fill="#fff" />
    <rect x="30.5" y="21.5" width="199.6" height="405.2" rx="18.6" stroke="#fff" stroke-width="5" />
    <foreignObject x="41" y="197" width="200" height="73">
      <div xmlns="http://www.w3.org/1999/xhtml" class="text-10 font-semibold text-gray-900">
        {{ $t('pages.your_providers') }}
      </div>
    </foreignObject>
    <path d="M216.4 261.8H41v1.5h175.4v-1.5Z" fill="#E8E8E8" />
    <text
      transform="translate(69.6 223.2)"
      fill="#2E3238"
      font-family="sans-serif"
      font-size="11"
      font-weight="600"
    >
      <tspan x="0" y="10.4">Wise</tspan>
    </text>
    <foreignObject x="70" y="238" width="175" height="73">
      <div xmlns="http://www.w3.org/1999/xhtml" class="text-10 text-gray-900">
        {{ $t('transfer_time.same_day') }}
      </div>
    </foreignObject>
    <rect x="45" y="223.4" width="19.5" height="19.5" rx="9.8" fill="#9FE870" />
    <path
      d="m47.7 235 3.7-4.3-2.2-4h12.3l-4.8 13H54l4-10.7h-5.1l1 1.9-1.7 2h2.9l-.8 2h-6.6Z"
      fill="#0B3200"
    />
    <foreignObject x="176" y="223" width="175" height="73">
      <div xmlns="http://www.w3.org/1999/xhtml" class="text-10 font-bold text-gray-900">
        {{ formatMoney(3319, '', $lang, 0) }}
      </div>
    </foreignObject>
    <path d="M216.4 312.5H41v1.6h175.4v-1.6Z" fill="#E8E8E8" />
    <rect x="44.8" y="273.5" width="19.5" height="19.5" rx="9.8" fill="#FD0" />
    <g fill="#000">
      <path
        d="M51.5 286.6c.7 1.3 2 1.3 2.7 0l.4-.7-3.7-6.6h-3.6l4.2 7.3ZM59.4 283.8c-.3.5-1 .5-1.2 0l-2.6-4.5H52l4.2 7.3c.8 1.3 2 1.3 2.8 0l2.8-4.9-1.4-2.4h-3.6l2.6 4.5Z"
      />
    </g>
    <text
      transform="translate(69.6 274)"
      fill="#2E3238"
      font-family="sans-serif"
      font-size="11"
      font-weight="600"
    >
      <tspan x="0" y="10.4">Western Union</tspan>
    </text>
    <foreignObject x="70" y="290" width="175" height="73">
      <div xmlns="http://www.w3.org/1999/xhtml" class="text-10 text-gray-900">
        {{ $t('transfer_time.in_minutes') }}
      </div>
    </foreignObject>
    <foreignObject x="176" y="275" width="175" height="73">
      <div xmlns="http://www.w3.org/1999/xhtml" class="text-10 font-bold text-gray-900">
        {{ formatMoney(3273, '', $lang, 0) }}
      </div>
    </foreignObject>
    <path d="M216.4 363.3H41v1.5h175.4v-1.5Z" fill="#E8E8E8" />
    <rect x="44.8" y="324.3" width="19.5" height="19.5" rx="9.8" fill="#fff" />
    <g fill="#813FD6">
      <path
        d="M55.4 327.2h.1l4.5 2.6 1.4 5a.2.2 0 0 1 0 .2l-2.5 4.4-.1.1-5 1.4a.2.2 0 0 1-.1 0l-4.5-2.6-1.4-5a.2.2 0 0 1 0-.1l2.5-4.5h.1l5-1.5m0-.5h-.2l-5 1.4a.7.7 0 0 0-.3.3l-2.5 4.5c-.1.2-.2.3-.1.5l1.4 5 .3.4 4.5 2.5h.5l5-1.3a.7.7 0 0 0 .3-.3l2.5-4.5a.7.7 0 0 0 .1-.5l-1.4-5c0-.1-.1-.3-.3-.3l-4.5-2.6h-.3Z"
      />
      <path
        opacity=".7"
        d="m53.7 331.6-.8 2v.6l.7 2a.4.4 0 0 0 .2.3h.1l.7-2 .1-.4v-.2l-.7-2a.4.4 0 0 0-.3-.3ZM58.6 331.5H57v.1l-.8 2V334.2l.7 2.2.2.1 1.7-4.8a.2.2 0 0 0 0-.1.2.2 0 0 0-.2-.1Z"
      />
      <path
        d="M53.7 336.6h-1.6l-1.7-4.9a.2.2 0 0 1 0-.2h1.8v.1l1.7 4.8a.2.2 0 0 1 0 .2h-.2ZM57 336.6H55.3l-1.6-4.9a.2.2 0 0 1 0-.2H55.5l.1.1 1.7 4.8a.2.2 0 0 1 0 .2H57Z"
      />
    </g>
    <text
      transform="translate(69.6 324.7)"
      fill="#2E3238"
      font-family="sans-serif"
      font-size="11"
      font-weight="600"
    >
      <tspan x="0" y="10.4">WordRemit</tspan>
    </text>
    <foreignObject x="70" y="341" width="175" height="73">
      <div xmlns="http://www.w3.org/1999/xhtml" class="text-10 text-gray-900">
        {{ $t('transfer_time.from_to_days', { min: '1', max: '3' }) }}
      </div>
    </foreignObject>
    <foreignObject x="176" y="325" width="175" height="73">
      <div xmlns="http://www.w3.org/1999/xhtml" class="text-10 font-bold text-gray-900">
        {{ formatMoney(3270, '', $lang, 0) }}
      </div>
    </foreignObject>
    <rect x="102.5" y="30" width="56.4" height="15.1" rx="7.6" fill="#F2F2F2" />
    <rect x="40.1" y="62.3" width="177.4" height="118.9" rx="7.1" fill="#fff" />
    <foreignObject x="40" y="54" width="178" height="30">
      <div xmlns="http://www.w3.org/1999/xhtml">
        <div
          class="flex justify-between bg-brand-800 rounded-tl-6 rounded-tr-6 text-10 font-semibold text-white py-2 pl-2 pr-3 w-full"
        >
          <span>{{ $t('label.best_deal') }}</span>
          <span class="text-right"> {{ $t('transfer_comparison.recipient_gets') }} </span>
        </div>
      </div>
    </foreignObject>
    <mask id="e" fill="#fff">
      <path d="M40 68.3a6 6 0 0 1 6-6h165.4a6 6 0 0 1 6 6v14H40.1v-14Z" />
    </mask>
    <path
      d="M39.3 68.3c0-3.7 3-6.8 6.8-6.8h165.3c3.8 0 6.8 3 6.8 6.8h-1.5c0-2.9-2.4-5.2-5.3-5.2H46.1c-3 0-5.3 2.3-5.3 5.2h-1.5Zm178.1 14H40.1h177.3Zm-178.1 0v-14c0-3.7 3-6.8 6.8-6.8v1.6c-3 0-5.3 2.3-5.3 5.2v14h-1.5Zm172.1-20.8c3.8 0 6.8 3 6.8 6.8v14h-1.5v-14c0-2.9-2.4-5.2-5.3-5.2v-1.6Z"
      fill="#389200"
      mask="url(#e)"
    />
    <mask id="f" fill="#fff">
      <path d="M40 82.3h177.4V176a6 6 0 0 1-6 6H46.1a6 6 0 0 1-6-6V82.3Z" />
    </mask>
    <path
      d="M40 82.3h177.4H40.1ZM219.3 176c0 4.4-3.5 7.8-7.8 7.8H46.1a7.8 7.8 0 0 1-7.8-7.8h3.5c0 2.4 2 4.3 4.3 4.3h165.3c2.4 0 4.3-2 4.3-4.3h3.5Zm-173.1 7.8a7.8 7.8 0 0 1-7.8-7.8V82.3h3.5V176c0 2.4 2 4.3 4.3 4.3v3.5ZM219.2 82.3V176c0 4.4-3.5 7.8-7.8 7.8v-3.5c2.4 0 4.3-2 4.3-4.3V82.3h3.5Z"
      fill="#389200"
      mask="url(#f)"
    />
    <rect x="47.6" y="100.7" width="18.7" height="19" rx="9.4" fill="#fff" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m62 104.5-4.4-3.2a.6.6 0 0 0-.8 0l-2 1.4a.5.5 0 0 1-.3.1.5.5 0 0 1-.5-.4.5.5 0 0 1 .2-.5l1.4-1 1.3-1c.6-.5 1.6-.4 2.2.2h.5l2.4-1.8v6.2Zm0 1.3-.2.3c-.1.2-.4.2-.6 0l-2.2-1.5h-.5a.4.4 0 0 0 0 .3.4.4 0 0 0 0 .3h.1l2 1.4.2.4c0 .2 0 .3-.2.4a.5.5 0 0 1-.6 0l-2.5-1.7H57a.4.4 0 0 0 0 .3.4.4 0 0 0 0 .3l2 1.4c.2.1.3.2.3.4s0 .3-.2.4a.5.5 0 0 1-.6 0l-.5-.2-2-1.5h-.5a.4.4 0 0 0 0 .4v.2l2 1.4c.2.1.3.2.3.4s0 .3-.2.4l-.3.2H57l-4.8-3.6v-7.9l2.1 1.6.7.4-1.2 1a1.3 1.3 0 0 0-.6.8 1.3 1.3 0 0 0 2.1 1.3L57 102a.4.4 0 0 1 .4 0l4.4 3.3a.5.5 0 0 1 .2.4Zm-.5-8-2 1.4h-.2a2.5 2.5 0 0 0-2.8 0l-.9.6-2.8-2h8.7Zm1.2-.7a.4.4 0 0 0-.3-.1H51.8a.4.4 0 0 0-.3.2v9.5l5.2 3.7a.7.7 0 0 0 .9 0l5-3.7a.4.4 0 0 0 .2-.3V97Z"
      fill="#212E61"
    />
    <text
      transform="translate(70.2 94.8)"
      fill="#2E3238"
      font-family="sans-serif"
      font-size="12"
      font-weight="600"
    >
      <tspan x="0" y="11.1">Remitly</tspan>
    </text>
    <foreignObject x="71" y="112" width="175" height="73">
      <div xmlns="http://www.w3.org/1999/xhtml" class="text-10 text-gray-900">
        {{ $t('transfer_time.next_day') }}
      </div>
    </foreignObject>
    <foreignObject x="176" y="96" width="175" height="73">
      <div xmlns="http://www.w3.org/1999/xhtml" class="text-10 font-bold text-gray-900">
        {{ formatMoney(3325, '', $lang, 0) }}
      </div>
    </foreignObject>
    <foreignObject x="46" y="139" width="175" height="73">
      <div xmlns="http://www.w3.org/1999/xhtml" class="flex">
        <div
          class="p-2 min-w-18 border border-solid border-gray-400 text-gray-900 rounded-4 ml-auto mr-2 font-semibold text-10 text-center"
        >
          {{ $t('details') }}
        </div>
        <div
          class="p-2 mr-4 min-w-18 btn-amber flex justify-center items-center rounded-4 font-semibold text-10 text-center"
        >
          {{ $t('go') }}
        </div>
      </div>
    </foreignObject>
    <path fill="url(#i)" fill-opacity=".3" d="M28 338h205v36H28z" />
    <defs>
      <linearGradient id="i" x1="125.5" y1="338" x2="125.5" y2="374" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff" />
        <stop offset="1" stop-color="#CCC" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script lang="ts" setup>
const { $lang } = useNuxtApp()
</script>
